<div class="mb-3">
    <div>
        <label class="form-label">{{to.label}}</label>
    </div>
    <div>    
        <span>Click <a class="attachmentLink" (click)="openFileInNewWindow()">here</a> to view the document </span>
    </div>
</div>
